import React from 'react';
import { FieldGroup } from '../../../libs/formLib';
import PropTypes from 'prop-types';
import moment from 'moment';

export default function VendorDaysBack({ bugsDateBack, vendorId, setBugsDateBack, isSubmitted }) {
  // console.log('max', max);
  let sixAgo = moment().subtract(6, 'months');
  // console.log('six ago: ', sixAgo.format('DD-MM-YYYY'));

  return (
    <FieldGroup
      type="date"
      id="dateBack"
      // step="1"
      // pattern="\d+"
      label="Look for bugs from"
      showFeedback={!bugsDateBack && isSubmitted}
      feedback="Please specify a date."
      onChange={e => setBugsDateBack(e.target.value)}
      value={bugsDateBack}
      max={new Date().toISOString().split('T')[0]}
      min={vendorId === 'msft365' || vendorId === 'msftserver' ? sixAgo.format('YYYY-MM-DD') : null}
      style={{ marginBottom: '10px' }}
      help={
        vendorId === 'msft365' || vendorId === 'msftserver'
          ? 'This service can get bugs updated in the last 6 months.'
          : 'Eg. Look for bugs from 11/11/2021 onwards.'
      }
      required
      data-testid={'days-back'}
      // tooltip={'Days back tooltip'}
    />
  );
}
VendorDaysBack.propTypes = {
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  isSubmitted: PropTypes.bool,
  vendorId: PropTypes.string
};
